import { Navigate, Outlet } from "react-router";
import Cookies from "js-cookie";

type Props = {
  allowedRoles: number[];
};

export default function ProtectedRoute({ allowedRoles }: Props) {
  const token = Cookies.get("token");
  const customerType = Number(Cookies.get("customerType"));

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!allowedRoles.includes(customerType)) {
    switch (customerType) {
      case 1:
        return <Navigate to="/search" replace />;
      case 2:
        return <Navigate to="/dashboard" replace />;

      case 3:
        return <Navigate to="/dealer" replace />;

      default:
        return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
}